import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { getYear } from 'date-fns';
@Component({
  selector: 'a-mat-calendar-year',
  templateUrl: './a-mat-calendar-year.component.html',
  styleUrls: ['./a-mat-calendar-year.component.scss'],
})
export class AMatCalendarYearComponent implements OnInit {

  @Input() activeDate: Date;
  @Input() currentYear?: number;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Output() onYearClick: EventEmitter<number> = new EventEmitter();

  yearList: number[] = [];
  activeYear: number;


  maxYear: number;
  minYear: number;

  previousBtnDisabled = false;
  nextBtnDisabled = false;

  constructor() { }

  ngOnInit(): void {
    this.maxYear = getYear(this.maxDate);
    this.minYear = getYear(this.minDate);
    this.activeYear = getYear(this.activeDate);
    if (!this.currentYear) {
      this.currentYear = this.activeYear;
    }
    this.calculateYearRange();
  }

  calculateYearRange() {
    let seedYear = this.currentYear;
    const startYear = seedYear - 6;
    const endYear = seedYear + 6;
    this.yearList = [];
    for (let i = startYear; i < endYear; i++) {
      this.yearList.push(i);
    }
    this.checkButtonsCanBeClick();
  }

  previousYearList() {
    const seedYear = this.yearList[0];
    const startYear = seedYear - 12;
    this.yearList = [];
    for (let i = startYear; i < seedYear; i++) {
      this.yearList.push(i);
    }
    this.checkButtonsCanBeClick();
  }

  nextYearList() {
    const seedYear = this.yearList[this.yearList.length - 1];
    const endYear = seedYear + 12;
    this.yearList = [];
    for (let i = seedYear + 1; i <= endYear; i++) {
      this.yearList.push(i);
    }
    this.checkButtonsCanBeClick();
  }

  checkButtonsCanBeClick() {
    const startYear = this.yearList[0], endYear = this.yearList[this.yearList.length - 1];
    if (startYear < this.minYear) {
      this.previousBtnDisabled = true;
    } else {
      this.previousBtnDisabled = false;
    }

    if (endYear > this.maxYear) {
      this.nextBtnDisabled = true;
    } else {
      this.nextBtnDisabled = false;
    }
  }

  yearClick(year: number) {
    this.onYearClick.emit(year);
  }

}
